//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './Text2.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const Text2 = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("Text2", props.addClasses)}>{props.children}</div>
  );
};

export default Text2;